/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Alert,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import {
  addEmailFieldChange,
  addNumberFieldChange,
  getCompanyNumbers,
  uploadFile,
  editNumberFieldChange as editNumberFieldChangeAction,
} from '../../../actions/Numbers';
import util from '../../../lib/utils';
import CompanyAutocomplete from '../../CompanyAutocomplete';
import MultiInput from '../../MultiInput';
import NumberTypeSelect from '../../Numbers/NumberTypeSelect';
import UsersAutocomplete from '../../Numbers/UsersAutocomplete';
import remove from '../../../Res/Icon/remove.png';
import MultiInputDrag from '../../MultiInputDrag';
import { getVoicePorts } from '../../../actions/EpikBoxes';
import Toggle from '../../Toggle';
import {
  changeBulkBoxSession,
  enableBulkBoxSession,
  resetBulkBoxSession,
} from '../../../actions/BoxSessionLogging';

const groupItems = [
  { label: 'Ring All', value: 'Ring All', tooltip: 'Rings all numbers at the same type' },
  {
    label: 'Round Robin',
    value: 'Round Robin',
    tooltip: 'Rings each port in a defined sequence for 30 seconds before ringing next port',
  },
];

class AddNumberForm extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.onNumberChange = this.onNumberChange.bind(this);
    this.state = {
      checkedBox: false,
      numDigits: 1,
      spoofType: 'same',
      ports: [],
    };
    this.portArr = [];
  }

  async componentDidMount() {
    const { user, boxDetails, getVoicePorts, resetBulkBoxSession } = this.props;

    //reset all bulk box session on mount
    resetBulkBoxSession();
    await this.props.getCompanyNumbers(this.token, boxDetails.assignedTo._id, true);
    if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
      this.props.addEmailFieldChange(this.props.email.emails);
    }
    this.props.addNumberFieldChange('company', boxDetails.assignedTo._id);
    this.props.addNumberFieldChange('assignedTo', boxDetails.epikBoxUser._id);
    this.props.addNumberFieldChange('numDigits', '1');
    this.props.addNumberFieldChange('cidOverride', '+');
    this.props.addNumberFieldChange('forwardNumbers', []);
    this.props.addNumberFieldChange('huntType', 'Hunt');
    this.props.addNumberFieldChange('huntPorts', []);

    const res = await getVoicePorts(this.token, boxDetails._id);
    if (res) {
      this.allPorts = res;
      this.setState({ selectedPort: this.allPorts[0] });
    }
  }

  onNumberChange(faxNumber) {
    this.props.addNumberFieldChange('number', faxNumber);
  }

  onAddedCompanyChange = async ({ name, value, suggestion }) => {
    const { addEmailFieldChange, addNumberFieldChange } = this.props;
    if (suggestion) {
      const uid = true;
      await this.props.getCompanyNumbers(this.token, suggestion._id, uid);
      addNumberFieldChange(name, suggestion._id);
      addEmailFieldChange(this.props.email.emails);
      const assigned = this.props.emails && this.props.emails[0];
      addNumberFieldChange('assignedTo', { email: assigned.email, _id: assigned._id });
    } else {
      addEmailFieldChange([]);
      addNumberFieldChange('company', value);
      addNumberFieldChange('userName', '');
    }
  };

  onAddedEmailChange = ({ name, suggestion }) => {
    if (suggestion) {
      this.props.addNumberFieldChange(name, suggestion._id);
    } else {
      this.props.addNumberFieldChange(name, '');
    }
  };

  onNumberTypeSelect = numberType => {
    const { addNumberFieldChange, changeBulkBoxSession, number } = this.props;
    // [Action] - Added
    changeBulkBoxSession(
      `Number Type changed from ${number?.type || '-'} to ${numberType?.value}`,
      'numberType',
    );
    addNumberFieldChange('type', numberType?.value);
  };

  onUserTypeSelect = numberType => {
    const number = numberType ? numberType?.value : '';
    if (number !== '' && number !== undefined) {
      this.props.addNumberFieldChange('assignedTo', { email: number.email, _id: number._id });
    }
  };

  onAllowedUserSelect = ({ suggestion }) => {
    const { number, changeBulkBoxSession } = this.props;

    if (suggestion !== null) {
      let addArray = true;
      number.allowedUsers.forEach(item => {
        if (item._id === suggestion._id) {
          addArray = false;
        }
      });
      if (addArray) {
        // [Action] - Added
        changeBulkBoxSession(
          `Allowed User(s) Added - ${JSON.stringify([...number.allowedUsers, suggestion])}`,
          'allowedUsers',
        );
        this.onAddedArrChange([...number.allowedUsers, suggestion], 'allowedUsers');
      }
    }
  };

  onAddedUserChange = ev => {
    const { name, value } = ev.target;
    const { number } = this.props;

    // [Action] - Added
    this.props.changeBulkBoxSession(
      `Caller ID changed from ${number?.cid || '-'} to ${value} `,
      'callerID',
    );
    this.props.addNumberFieldChange(name, value);
    this.props.addNumberFieldChange('cidOverride', value);
  };

  onAddedArrChange = (ev, type) => {
    if (this.props.type === 'ringDown') {
      if (ev.length > 1) {
        toast.error("You can't add more than one number.");
      } else {
        this.props.addNumberFieldChange(type, ev);
      }
    } else {
      this.props.addNumberFieldChange(type, ev);
    }
  };

  onAddedArrNumChange = ev => {
    const { number } = this.props;
    const { name, value } = ev.target;
    this.props.addNumberFieldChange(name, [value]);
    // [Action] - Added
    this.props.changeBulkBoxSession(`Forward Number changed to ${value}`, 'forwardNumber');
  };

  onAddedNumberChange = ev => {
    const { name, value } = ev.target;
    const { number } = this.props;

    const reg = /^[+]*[0-9]{1,11}$/g;

    // [Action] - Added
    this.props.changeBulkBoxSession(`Number changed to ${value}`, 'numberAdded');
    if (reg.test(value)) {
      this.props.addNumberFieldChange(name, value);
    }
  };

  sortPort = () => {
    const { selectedPort } = this.props;
    if (this.allPorts) {
      let filtered = this.allPorts.filter(function(value) {
        return value !== selectedPort.boxPortNumber;
      });

      if (this.state !== undefined) {
        filtered = filtered.filter(val => {
          return this.state.ports.indexOf(val) === -1;
        });
      }
      return filtered.sort() || [];
    }
    return [];
  };

  onFwdNumberChange = ev => {
    const reg = /^[+]*[0-9]{1,11}$/g;
    const { name, value } = ev.target;
    const { number } = this.props;

    // [Action] - Added
    this.props.changeBulkBoxSession(
      `Forward Number changed from ${
        number?.forwardNumbers ? number.forwardNumbers[0] : ''
      } to ${value}`,
      'forwardNumber',
    );

    if (reg.test(value)) {
      this.props.addNumberFieldChange(name, [value]);
    }
  };

  onAddConfirmationEmail = e => {
    // [Action] - Added
    const { number } = this.props;
    this.props.changeBulkBoxSession(
      `Confirmation Email changed from ${number?.confirmationEmail || '-'} to ${e.target.value}`,
      'confirmationEmail',
    );
    this.props.addNumberFieldChange('confirmationEmail', e.target.value);
  };
  setCheckedBox = e => {
    this.setState({ checkedBox: e });
    this.props.addNumberFieldChange('spoofIncomingCid', e);
  };

  handleNumberDigit = e => {
    // [Action] - Added
    const { numDigits } = this.state;

    this.props.changeBulkBoxSession(
      `Number of digits changed ${numDigits || '-'} to ${e.target.value}`,
      'numberOfDigits',
    );

    if (e.target.value.length <= 1) {
      if (e.target.value >= 0 && e.target.value <= 3) {
        if (e.target.value == 0) {
          this.setState({ numDigits: 1 }, () => {
            this.props.addNumberFieldChange('numDigits', 1);
          });
        } else {
          this.setState({ numDigits: e.target.value }, () => {
            this.props.addNumberFieldChange('numDigits', this.state.numDigits);
          });
        }
      } else {
        this.setState({ numDigits: 1 }, () => {
          this.props.addNumberFieldChange('numDigits', 1);
        });
      }
    }
  };

  handleNumberType = (e, type) => {
    const { append, same, prepend } = this.state;
    this.props.changeBulkBoxSession(`spoofType changed to ${type || '-'}`, 'samePrependAppend');
    this.setState({ [e.target.name]: type });
    this.props.addNumberFieldChange(e.target.name, type);
  };

  removeValue = e => {
    const { number } = this.props;
    const valuesWIthRemoved = number.allowedUsers.filter((val, idx) => idx !== e);
    this.onAddedArrChange(valuesWIthRemoved, 'allowedUsers');
  };

  move = (from, to, arr = this.state.ports) => {
    const { addNumberFieldChange, selectedPort } = this.props;
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    this.setState({ ports: clone });
    addNumberFieldChange('huntPorts', [selectedPort.boxPortNumber].concat(clone));
  };

  removePort = e => {
    const { addNumberFieldChange } = this.props;
    const array = [...this.state.ports];
    array.splice(e, 1);
    this.setState({ ports: array }, () => {
      addNumberFieldChange('huntPorts', this.state.ports);
    });
  };

  setPortName = e => {
    const { selectedPort, addNumberFieldChange } = this.props;
    this.setState({ selectedPort: e });
    let found = false;
    if (selectedPort.boxPortNumber === e) {
      toast.error('Cannot select box port');
    } else if (this.state.ports.length === 0) {
      this.state.ports.push(e);
    } else {
      this.state.ports.forEach((item, idx) => {
        if (item === e) {
          found = true;
        }
        if (idx === this.state.ports.length - 1) {
          if (found) {
            toast.error('Port already selected');
          } else {
            this.state.ports.push(e);
          }
        }
      });
    }
    addNumberFieldChange('huntPorts', [selectedPort.boxPortNumber].concat(this.state.ports));
    this.setState({ ports: this.state.ports });
  };

  render() {
    const {
      companies,
      type,
      number,
      email,
      emails,
      user,
      addNumberFieldChange,
      selectedPort,
      changeBulkBoxSession,
    } = this.props;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                <Input
                  required
                  type="text"
                  name="number"
                  value={number.number}
                  onChange={this.onAddedNumberChange}
                  maxLength={12}
                />
              </Col>
              <Col sm={type === 'hunt' ? 3 : 6}>
                <Label for="type" sm={12}>
                  Type
                </Label>
                <NumberTypeSelect
                  required
                  name="type"
                  onTypeSelect={this.onNumberTypeSelect}
                  selectedType={number.type}
                  e911Enabled={this.props.boxDetails?.e911Number}
                />
              </Col>
              {type === 'hunt' && (
                <Col sm={3}>
                  <Label for="type" sm={12}>
                    Hunt Type
                  </Label>
                  <Input
                    type="select"
                    onChange={e => {
                      // [BulkAction] - Change

                      changeBulkBoxSession(
                        `Hunt Type Added - ${e.currentTarget.value}`,
                        'huntType',
                      );
                      addNumberFieldChange('huntType', e.currentTarget.value);
                    }}
                  >
                    {groupItems.map((item, idx) => {
                      return (
                        <option key={idx} value={item.value} title={item.tooltip}>
                          {item.label}
                        </option>
                      );
                    })}
                  </Input>
                </Col>
              )}
            </FormGroup>
            {user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <CompanyAutocomplete
                    isDisabled
                    searchTerm={this.props.boxDetails.assignedTo.name}
                    placeholder="Filter Company..."
                    companies={companies.docs || []}
                    onChange={() => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(`Company Added - ${companies.docs || []}`, 'company');
                      console.log('');
                    }}
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {/* {emails.length > 0 ? ( */}
                  <UsersAutocomplete
                    disabledAdmin
                    searchTerm={this.props.boxDetails.epikBoxUser.email}
                    callsItem={emails || []}
                    placeholder="User..."
                    calls={emails || []}
                    onChange={e => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(`User Added - ${e}`, 'user');
                      console.log('');
                    }}
                  />
                  {/* ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Choose the company
                    </Alert>
                  )} */}
                </Col>
              </FormGroup>
            ) : (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <Input value={user.company && user.company.name} readOnly />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  <UsersAutocomplete
                    searchTerm={this.props.boxDetails.epikBoxUser.email}
                    callsItem={emails || []}
                    placeholder="User..."
                    calls={emails || []}
                    onChange={e => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(`User Added - ${e}`, 'user');
                      console.log('');
                    }}
                  />
                </Col>
              </FormGroup>
            )}
            <FormGroup row />
            {type === 'fax' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Email(s)
                    </Label>
                    <MultiInput
                      inputData={number.emails || []}
                      onChange={e => {
                        // [BulkAction] - Added
                        changeBulkBoxSession(`Email(s) Added - ${e?.toString()} `, 'emails');
                        this.onAddedArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="email" sm={12}>
                      Fallback email(s)
                    </Label>
                    <MultiInput
                      inputData={number.fallbackEmails || []}
                      onChange={e => {
                        // [BulkAction] - Added
                        changeBulkBoxSession(
                          `Fallback Email(s) Added - ${e?.toString()}`,
                          'fallbackEmails',
                        );
                        this.onAddedArrChange(e, 'fallbackEmails');
                      }}
                      validator={util.validateEmail}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col name="forwardUris" sm={6}>
                    <Label for="type" sm={12}>
                      {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                    </Label>
                    <MultiInput
                      inputData={(number.forwardUris && number.forwardUris) || []}
                      onChange={e => {
                        // [BulkAction] - Added
                        changeBulkBoxSession(
                          `${
                            type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                          } Added - ${e.toString()}`,
                          'forwardUris',
                        );
                        this.onAddedArrChange(e, 'forwardUris');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="deliveryConfirmations" sm={12}>
                      Delivery Confirmations
                    </Label>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={number.faxDeliveryConfirmation}
                        onToggle={() => {
                          if (number && number.forwardUris.length !== 0) {
                            this.onAddedArrChange(
                              !number.faxDeliveryConfirmation,
                              'faxDeliveryConfirmation',
                            );
                          } else {
                            toast.info('Forward URI not configured!');
                            console.log('not configured');
                          }
                        }}
                      />
                    </Col>
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'vmail' && (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Notification email(s)
                  </Label>
                  <MultiInput
                    inputData={number.fallbackEmails || []}
                    onChange={e => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(
                        `Notification Email(s) Added - ${e?.toString()}`,
                        'notificationEmails',
                      );
                      this.onAddedArrChange(e, 'fallbackEmails');
                    }}
                    validator={util.validateEmail}
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    Notification number(s)
                  </Label>
                  <MultiInput
                    inputData={number.forwardNumbers || []}
                    onChange={e => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(
                        `Notification Number(s) Added - ${e?.toString()}`,
                        'notificationNumbers',
                      );
                      this.onAddedArrChange(e, 'forwardNumbers');
                    }}
                  />
                </Col>
              </FormGroup>
            )}
            {type === 'dialout' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Allowed number(s)
                    </Label>
                    <MultiInput
                      inputData={number.allowedNumbers || []}
                      onChange={e => {
                        // [BulkAction] - Added
                        changeBulkBoxSession(
                          `Allowed Number(s) Added - ${e?.toString()}`,
                          'allowedNumbers',
                        );
                        this.onAddedArrChange(e, 'allowedNumbers');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Forward number
                    </Label>
                    <Input
                      required
                      type="text"
                      name="forwardNumbers"
                      value={number.forwardNumbers || []}
                      onChange={this.onAddedArrNumChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Caller ID
                    </Label>
                    <Input
                      required
                      type="text"
                      name="cid"
                      value={number.cid || []}
                      onChange={this.onAddedUserChange}
                    />
                  </Col>
                  <Col sm={6}>
                    <Row>
                      <Col sm={12}>
                        <Label for="spoofIncomingCid" sm={6}>
                          <Input
                            type="checkbox"
                            id="spoofIncomingCid"
                            onChange={() => {
                              // [BulkAction] - Enable
                              enableBulkBoxSession(
                                'Spoof Incoming Cid changed from disable to enabled',
                                'spoofIncomingCidEnabled',
                              );
                              this.setCheckedBox(!this.state.checkedBox);
                            }}
                            checked={this.state.checkedBox}
                            disabled={
                              (number.cid && number.cid.length < 10) ||
                              number.cid === '' ||
                              number.cid === undefined
                            }
                          />
                          Spoof cid
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'prepend')}
                            disabled={!this.state.checkedBox}
                          />
                          prepend
                        </Label>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'append')}
                            disabled={!this.state.checkedBox}
                          />
                          append
                        </Label>
                        <Label check sm={6}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'same')}
                            disabled={!this.state.checkedBox}
                          />
                          Same called number
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <Label sm={4} for="numDigits" style={{ minWidth: '120px', margin: 0 }}>
                          Number of digits
                        </Label>
                        <Input
                          disabled={this.state.spoofType === 'same'}
                          type="number"
                          id="numDigits"
                          name="numDigits"
                          onChange={this.handleNumberDigit}
                          value={this.state.numDigits}
                          max={3}
                          min={1}
                        />
                      </Col>
                    </Row>
                  </Col>
                </FormGroup>
              </>
            )}
            {type !== 'vmail' &&
            type !== 'dialout' &&
            type !== 'unassigned' &&
            type !== 'fax' &&
            type !== 'forward' ? (
              <FormGroup row>
                <Col name="forwardUris" sm={6}>
                  <Label for="type" sm={12}>
                    {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                  </Label>
                  <MultiInput
                    inputData={(number.forwardUris && number.forwardUris) || []}
                    onChange={e => {
                      // [BulkAction] - Added
                      changeBulkBoxSession(
                        `${
                          type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                        } Added - ${e?.toString()}`,
                        'forwardUris',
                      );
                      this.onAddedArrChange(e, 'forwardUris');
                    }}
                  />
                </Col>
                {type === 'hunt' && (
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Add port to hunt
                    </Label>
                    {this.sortPort() && this.sortPort().length !== 0 ? (
                      <ButtonDropdown
                        isOpen={this.state.drop}
                        toggle={() => {
                          this.setState({ drop: !this.state.drop });
                        }}
                        style={{ width: '100%' }}
                      >
                        <DropdownToggle
                          style={{
                            borderRight: 'none',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                          caret
                        >
                          {this.state.selectedPort}
                        </DropdownToggle>
                        <DropdownMenu
                          style={{
                            maxHeight: '300px',
                            overflow: 'hidden',
                            borderRight: 'none',
                            width: '100%',
                          }}
                        >
                          {this.sortPort().length !== 0 &&
                            this.sortPort().map((port, i) => (
                              <div key={i}>
                                <DropdownItem
                                  onClick={() => {
                                    let portName = port || `port ${i + 1}`;
                                    // [BulkAction] - Added
                                    changeBulkBoxSession(
                                      `Port Name Added - ${portName}`,
                                      'portName',
                                    );
                                    this.setPortName(portName);
                                  }}
                                >
                                  {port || `port ${i + 1}`}
                                </DropdownItem>
                              </div>
                            ))}
                        </DropdownMenu>
                      </ButtonDropdown>
                    ) : (
                      <Alert colSpan={2} color="info" className="price-not-found-alert">
                        No voice ports configured on this box yet
                      </Alert>
                    )}
                    {this.state.ports.length !== 0 && (
                      <>
                        <Label for="type" sm={12}>
                          Ring Order
                        </Label>
                        <MultiInputDrag
                          defaultPort={selectedPort?.boxPortNumber}
                          removePort={this.removePort}
                          type="port"
                          customClass="port-dnd"
                          inputData={this.state.ports}
                          move={this.move}
                          disabledAdmin
                        />
                      </>
                    )}
                  </Col>
                )}
              </FormGroup>
            ) : null}

            {type === 'fax' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Confirmation email
                  </Label>
                  {number && number.forwardUris.length !== 0 ? (
                    <Input
                      type="email"
                      placeholder="please specify"
                      value={number.confirmationEmail}
                      onChange={this.onAddConfirmationEmail}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Forward URI not configured
                    </Alert>
                  )}
                </Col>
                <Col sm={6}>
                  <Label for="deliveryConfirmations" sm={12}>
                    Delivery Confirmations
                  </Label>
                  <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={number.faxDeliveryConfirmation}
                      onToggle={() => {
                        if (number && number.forwardUris.length !== 0) {
                          this.onAddedArrChange(
                            !number.faxDeliveryConfirmation,
                            'faxDeliveryConfirmation',
                          );
                        } else {
                          toast.info('Forward URI not configured!');
                          console.log('not configured');
                        }
                      }}
                    />
                  </Col>
                </Col>
              </FormGroup>
            ) : null}

            {type === 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Forward Number
                  </Label>
                  <Input
                    required
                    type="text"
                    name="forwardNumbers"
                    value={number?.forwardNumbers ? number.forwardNumbers[0] : ''}
                    onChange={this.onFwdNumberChange}
                    maxLength={12}
                  />
                </Col>
              </FormGroup>
            ) : null}
            <FormGroup row>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  Allowed User(s)
                </Label>
                <UsersAutocomplete
                  callsItem={emails || []}
                  allowedUsers
                  placeholder="Allowed users"
                  calls={(email && email.emails) || []}
                  onChange={this.onAllowedUserSelect}
                />
                <div className="email-list">
                  {number.allowedUsers.map((value, idx) => {
                    return (
                      <div className="multi-input-item" key={value._id}>
                        <span className="item">{value.email}</span>
                        <img
                          className="remove-icon"
                          src={remove}
                          onClick={() => this.removeValue(idx)}
                          alt="remove"
                        />
                      </div>
                    );
                  })}
                </div>
              </Col>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  numbers: state.AppState.numbers,
  number: state.UIState.numbers.addNumber,
  company: state.UIState.numbers.addNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.addNumber.type,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.addNumberFieldChange,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
});

const mapDispatchToProps = dispatch => ({
  addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
  addEmailFieldChange: emails => dispatch(addEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
  getVoicePorts: (token, id) => dispatch(getVoicePorts(token, id)),
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  enableBulkBoxSession: (description, key) => dispatch(enableBulkBoxSession(description, key)),
  resetBulkBoxSession: () => dispatch(resetBulkBoxSession()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNumberForm);
